module.exports = __webpack_public_path__ + "img/inspiration_03.4c8f3e5.webp";